<ng-container *ngIf="loaded; else loading">
  <div
    class="no-price"
    *ngIf="shouldContactSales$ | async; else dontContactSales"
  >
    {{ 'FRONTEND.STORE.CONTACT_SALES' | translate }}
  </div>
  <ng-template #dontContactSales>
    <div class="no-price" *ngIf="isFree$ | async; else notFree">
      <b>{{ 'FRONTEND.STORE.FREE' | translate }}</b>
    </div>
    <ng-template #notFree>
      <ng-container *ngIf="!isAddon">
        <ng-container
          *ngIf="hasVerifiedContract && billedProduct; else usePricing"
        >
          <div *ngFor="let tier of pricingTierData$ | async" class="price-box">
            <span>
              <span *ngIf="tier.isStartingPrice" class="starting-at">
                {{ 'FRONTEND.STORE.STARTING_AT' | translate }}
              </span>
              <b class="price-number">
                {{ tier.priceStringForTierWithoutFreq }}
              </b>
            </span>
            <span
              class="tier-billing-freq"
              [ngClass]="{ 'va-wrap': wrapFrequency }"
            >
              {{ tier.pricingTierForProduct }}
            </span>
          </div>
        </ng-container>
        <ng-template #usePricing>
          <ng-container *ngIf="pricing?.prices">
            <div
              *ngFor="let price of priceData$ | async; let i = index"
              class="price-box"
            >
              <span>
                <span *ngIf="price.isStartingPrice" class="starting-at">
                  {{ 'FRONTEND.STORE.STARTING_AT' | translate }}
                </span>
                <b class="price-number">
                  <ng-container *ngIf="i > 0">+</ng-container>
                  {{ price.priceStringForPricingWithoutFrequency }}
                </b>
                <span
                  *ngIf="
                    price.abbreviatedFrequencyString && useAbbreviatedFrequency
                  "
                  class="billing-freq-abbrev"
                  [ngClass]="{ 'va-wrap': wrapFrequency }"
                >
                  /{{ price.abbreviatedFrequencyString }}
                </span>
              </span>
              <span
                *ngIf="price.frequencyString && !useAbbreviatedFrequency"
                class="billing-freq"
                [ngClass]="{ 'va-wrap': wrapFrequency }"
              >
                {{ price.frequencyString }}
              </span>
            </div>
          </ng-container>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="isAddon">
        <div *ngIf="hasVerifiedContract && billedProduct; else useAddonPricing">
          <div *ngFor="let tier of pricingTierData$ | async" class="price-box">
            <span class="addon-billing-freq">
              {{ tier.pricingTierForAddon }}
            </span>
            <span>
              <span *ngIf="tier.isStartingPrice" class="starting-at">
                {{ 'FRONTEND.STORE.STARTING_AT' | translate }}
              </span>
              <b class="price-number">
                {{ tier.priceStringForTier }}
              </b>
            </span>
          </div>
        </div>
        <ng-template #useAddonPricing>
          <div class="price-box">
            <span
              *ngIf="pricing?.prices[0].frequency"
              class="addon-billing-freq"
            >
              {{ (priceData$ | async)[0]?.frequencyString }}
            </span>
            <span>
              <span
                *ngIf="pricing?.prices[0]?.isStartingPrice"
                class="starting-at"
              >
                {{ 'FRONTEND.STORE.STARTING_AT' | translate }}
              </span>
              <b class="price-number">
                {{
                  (priceData$ | async)[0]?.priceStringForPricingWithoutFrequency
                }}
              </b>
            </span>
          </div>
        </ng-template>
      </ng-container>
      <b
        class="price-box price-number"
        *ngIf="billedProduct && billedProduct.setupFee > 0"
      >
        + {{ billedProduct.setupFee | price$: billedProduct.currency | async }}
        {{ setupFeeString$ | async }}
      </b>
      <div
        class="commitment"
        *ngIf="
          billedProduct &&
          billedProduct.commitment &&
          billedProduct.commitment.initial > 1
        "
      >
        {{ commitmentMessage$ | async }}
      </div>
    </ng-template>
  </ng-template>
</ng-container>
<ng-template #loading>
  <div class="stencil-pricing stencil-shimmer"></div>
</ng-template>
